import styled from '@emotion/styled';
import { COLORS3, SPACING } from '@zola/zola-ui/src/styles/emotion';

export const HorizontalNavWrapper = styled.div`
  margin-left: 72px;
  position: relative;
  z-index: -2;
`;

type ScrollWrapperProps = {
  hideContentOnScroll: boolean;
  showSecondaryNav?: boolean;
};

export const ScrollWrapper = styled.div<ScrollWrapperProps>`
  display: grid;
  grid-template-columns: ${({ hideContentOnScroll, showSecondaryNav }) =>
    hideContentOnScroll && showSecondaryNav ? '1fr 1fr' : '1fr 0fr'};
  grid-template-rows: 1fr;
  border-bottom: 1px solid ${COLORS3.BLACK_030};
  position: relative;
  z-index: -2;
`;

export const SecondaryAndQuickLinksWrapper = styled.div<ScrollWrapperProps>`
  display: flex;
  height: ${({ hideContentOnScroll }) => (hideContentOnScroll ? '50px' : '56px')};
  padding: 0 ${SPACING.LG};
  justify-content: space-between;

  align-items: center;
  grid-row: ${({ hideContentOnScroll }) => (hideContentOnScroll ? '1' : '2')};
  transition: height 0.3s linear;
  position: relative;
  z-index: -2;
`;
